// extracted by mini-css-extract-plugin
export default {"wrapper":"YouPoop_wrapper__DJIYT"};